import gmx_zMixins         from '../../../../../includes/Jmixins/zMixins.js'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues.js'
import lmx_localData            from '../primitives/localData.js'
import lmx_watching             from './Watching.js'
import lmx_Events               from './Events.js'
import lmx_Links               from './Links.js'


import draw_Forms               from './draw_Forms.js'
import draw_Radial              from './draw_Radial.js'
import draw_RadialChart         from './draw_RadialChart.js'
import draw_Headers             from './draw_Headers.js'
import detail_Handover          from './detail_Handover.js'

import tbl_Handover             from './tbl_Handover.js'
import tbl_System               from './tbl_System.js'
import tbl_SubSystem            from './tbl_SubSystem.js'


export default {

  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_localData,
    lmx_watching,
    lmx_Events,
    lmx_Links,
    
    draw_Forms,
    draw_Radial,
    draw_RadialChart,
    draw_Headers,
    detail_Handover,

    tbl_Handover,
    tbl_System,
    tbl_SubSystem,
  ],
  
}
